import { Tab, Tabs } from "@mui/material";
import { useTranslate } from "react-admin";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { RequirePermission } from "../components/RequirePermission";
import { SalesforceReportDashboardContent } from "../components/SalesforceReportDashboardContent";
import { ResourceName } from "../constants/resources";
import { SALESFORCE_CHART_COLORS } from "../lib/salesforceDashboard";
import {
  findReportTab,
  SALESFORCE_REPORT_TABS,
  SALESFORCE_REPORTS_DEFAULT_PATH,
  salesforceReportPath,
} from "../lib/salesforceReport";
import { space } from "../theme/designTokens";

const colors = SALESFORCE_CHART_COLORS;

const ReportTabs = ({ slug }: { slug: string }) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  return (
    <Tabs
      aria-label={translate("salesforceReports.tabsLabel")}
      onChange={(_, value: string) => navigate(salesforceReportPath(value))}
      scrollButtons="auto"
      sx={{ mb: `${space.lg}px`, borderBottom: `1px solid ${colors.cardBorder}` }}
      value={slug}
      variant="scrollable"
    >
      {SALESFORCE_REPORT_TABS.map(reportTab => (
        <Tab
          key={reportTab.slug}
          label={translate(`salesforceReports.dashboards.${reportTab.dashboard}`)}
          sx={{ textTransform: "none" }}
          value={reportTab.slug}
        />
      ))}
    </Tabs>
  );
};

const SalesforceReportDashboardRoute = () => {
  const { dashboard } = useParams<{ dashboard: string }>();
  const tab = findReportTab(dashboard);
  if (!dashboard || !tab) return <Navigate to={SALESFORCE_REPORTS_DEFAULT_PATH} replace />;
  return (
    <SalesforceReportDashboardContent dashboard={tab.dashboard} slug={dashboard}>
      <ReportTabs slug={dashboard} />
    </SalesforceReportDashboardContent>
  );
};

export const SalesforceReportDashboardPage = () => (
  <RequirePermission permission={ResourceName.SalesforceReports}>
    <SalesforceReportDashboardRoute />
  </RequirePermission>
);
